<template>
  <div style="height: 100%">
    <fdc-panel
      :title="'데이터 CSV 파일 Import & Export'"
      style="height: 100%;"
    >
      <template #header>
        <div class="header-buttons">
          <b-button
            type="is-light"
            icon-left="import"
            @click="onClickImport()"
          >
            {{ $t('fdc.COMMON.BUTTON.IMPORT') }}
          </b-button>
          <b-button
            type="is-light"
            icon-left="export"
            @click="onClickExport()"
          >
            {{ $t('fdc.COMMON.BUTTON.EXPORT') }}
          </b-button>
        </div>
      </template>
      <brique-grid
        style="width: 100%; height: 70%;"
        id="csvImportExport"
        ref="CsvImportExportGrid"
        :brique-grid-columns="columnDefs"
        @grid-ready="onGridReady"
        :default-col-def="defaultColDef"
        :row-selection="rowSelection"
        :row-data="rowData"

        :brique-grid-is-view-header="true"
        :brique-grid-is-view-import-btn="true"
        :brique-grid-is-view-export-btn="true"
      />
      <hr>
      <monaco-editor
        ref="MonacoEditor"
        :code="comment"
        :automatic-layout="true"
        :read-only="true"
        :theme="'vs-dark'"
        style="height: 25%"
      />
    </fdc-panel>
  </div>
</template>

<script>
import MonacoEditor from '@/views/Fdc/EqpInfo/Components/MonacoEditor.vue'

export default {
  name: 'CsvImportExport',
  components: {
    'monaco-editor': MonacoEditor
  },
  methods: {
    async onGridReady (params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi

      await this.refreshData()
    },
    async refreshData () {
      const updateData = (data) => {
        this.rowData = data
        this.gridApi.setRowData(data)
      }

      await fetch('https://www.ag-grid.com/example-assets/olympic-winners.json')
        .then((resp) => resp.json())
        .then((data) => updateData(data.slice(0, 100).map(d => {
          d.date = d.date.split('/').reverse().join('/') // date format이 DD/MM/YYYY 여서 converting함
          return d
        })))
    },
    /**
     * Csv Import
     */
    onClickImport () {
      this.$refs.CsvImportExportGrid.onClickImportCsv()
    },
    /**
     * Csv Export
     */
    onClickExport () {
      this.$refs.CsvImportExportGrid.gridApi.exportDataAsCsv({
        fileName: 'export.csv'
      })
    }
  },
  data: function () {
    return {
      gridApi: null,
      columnApi: null,
      columnDefs: [
        { field: 'athlete', minWidth: 150, checkboxSelection: true },
        { field: 'age', maxWidth: 90, type: 'numericColumn' },
        { field: 'country', minWidth: 150 },
        { field: 'year', maxWidth: 90 },
        { field: 'date', minWidth: 150, type: 'dateColumn' },
        { field: 'sport', minWidth: 150 },
        { field: 'gold', type: 'numericColumn' },
        { field: 'silver', type: 'numericColumn' },
        { field: 'bronze', type: 'numericColumn' },
        { field: 'total', type: 'numericColumn' }
      ],
      defaultColDef: {
        // flex: 1,
        minWidth: 100,
        filter: true,
        resizable: true,
        sortable: true
      },
      rowSelection: 'multiple',
      rowData: null,
      comment: [
        '/*',
        ' * 주요 설정 (상세 사용법은 소스 참조)',
        ' * - BRIQUE Grid Component props 설정',
        ' * - BRIQUE Grid Component 외부 button 사용 시는 소스 참조',
        ' */',
        '` :brique-grid-is-view-header="true" `\t\t// BRIQUE Grid Header 활성화',
        '` :brique-grid-is-view-import-btn="true" `\t// import button 활성화',
        '` :brique-grid-is-view-export-btn="true" `\t// export button 활성화'
      ].join('\n')
    }
  }
}
</script>

<style lang="scss">
  .fdc-panel {
    .panel-body {
      padding: 10px;
    }
  }
</style>
